module.exports = __webpack_public_path__ + "static/media/example-2.f532a722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Dalyellup/example-2.jpg
// module id = 233
// module chunks = 0